import type { VaultsBenchmark } from '@vaultsfyi/common'

export function getBenchmarkKey(benchmark: VaultsBenchmark, key: string): string {
  return `${benchmark.name}-${key}`.replace(/\s/g, '-')
}
